/**
 * Experiment configuration constants
 *
 * Centralized location for experiment names and related configuration.
 * Update these values when launching new experiments or retiring old ones.
 */

/**
 * Multi-vertical experiment (Jan 2026) - tests multi-disease interest
 * Used for: Amplitude user property, analytics source
 * Note: URL param uses 'multi-disease' (set by marketing)
 */
export const MULTI_VERTICAL_EXPERIMENT_NAME = 'multi-vertical-test-jan26';
